<template>
  <header class="flex h-[60px] shadow-sm">
    <AppLogo/>
    <div></div>
  </header>
</template>

<style scoped >
header {
  background-color: var(--header-background);
  padding: 10px;
}
</style>
<script setup lang="ts">

import AppLogo from "~/components/AppLogo.vue";
</script>